module.exports = __webpack_public_path__ + "static/media/education-mahidol.8ca107b9.jpeg";